import React from 'react';
import Modal from '@active/react-ui/Modal';
import ModalBody from '@active/react-ui/ModalBody';
import ModalFooter from '@active/react-ui/ModalFooter';
import Button from '@active/react-ui/Button';
import { Locale } from '@active/react-utils/i18n';
import { useCheckScanner } from '../hooks/useCheckScanner';

export const CheckImageModal = () => {
  const {
    showImageModal, setShowImageModal, scanInfo,
  } = useCheckScanner();

  const {
    frontImage, backImage,
  } = scanInfo;

  const handleCloseModal = () => {
    setShowImageModal(false);
  };

  return (
    <Modal
      title={<Locale id="checkout.lib.components.payment.check.checkImg"/>}
      className="check-scanner-modal"
      shown={showImageModal}
      style={{ margin: 'auto' }}
      size='md'
      onClose={handleCloseModal}>
      <ModalBody>
        <div className="check-scanner-title">
          <Locale id="checkout.lib.components.payment.check.digital"/>
        </div>
        <div>
          <img className="check-scanner-img" src={frontImage} alt="check-scanner-front" />
          <img className="check-scanner-img" src={backImage} alt="check-scanner-back" />
        </div>
      </ModalBody>
      <ModalFooter className='modal-footer check-scanner-img-footer'>
        <div>
          <Button
            type="secondary"
            onClick={handleCloseModal}>
            <Locale id="checkout.lib.components.common.btn.cancel"/>
          </Button>
          <Button
            type="strong"
            style={{ marginLeft: '20px' }}
            onClick={handleCloseModal}>
            <Locale id="checkout.lib.components.common.btn.ok"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};
